import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.tsx";
import { applyTheme, storedTheme } from "./lib/theme";
import "./styles/globals.css";

// Antes de montar: si se hiciera dentro de un efecto, la primera pintura
// sería clara y el oscuro llegaría un cuadro después. Ese parpadeo blanco es
// justo lo que va a ver de noche quien eligió el tema oscuro.
applyTheme(storedTheme());

const container = document.getElementById("root");
if (!container) {
  // Sin el nodo no hay nada que montar. Fallar acá con un mensaje claro es
  // mejor que dejar que `createRoot(null!)` reviente adentro de React.
  throw new Error("Falta #root en index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
